const PortfolioBigCards = [
    {
        id: 123,
        layout: "big",
        animation_direction: "left",
        project_name: "Sistema Jurídico",
        project_url: "https://sistema-juridico.vercel.app/",
        project_git_url: "https://github.com/Valdoveste/Sistema-Juridico",
        project_img_alt: "Sistema Júridico Project Image",
        project_img: "https://i.imgur.com/f7iQ73o.png",
        project_desc: "Sistema Jurídico é solução que busca otimizar o setor jurídico empresarial, aprimorando eficiência e reduzindo erros. A migração das planilhas Excel para uma plataforma integrada é enfatizada, proporcionando acesso individualizado a usuários e habilitando gestão abrangente. Isso inclui recursos de inclusão, edição, visualização e histórico de alterações,assim capacitando empresas a priorizarem tarefas estratégicas e impulsionando a eficácia operacional.",
        project_tech: ["ANGULAR 15", ".NET RESTFUL API", "AZURE", "VERCEL", "BOOTSTRAP", "SASS", "MATERIAL-UI"]
    },
    {
        id: 456,
        layout: "big",
        animation_direction: "right",
        project_name: "Val Imóveis - Especialista Imobiliária",
        project_url: "https://www.val-imoveis7.com.br/",
        project_git_url: "https://github.com/Valdoveste/val-imoveis",
        project_img_alt: "Val Imóveis Project Image",
        project_img: "https://i.imgur.com/8PasGvG.png",
        project_desc: "Página dedicada a uma corretora de imóveis atuante desde 2010, oferecendo uma solução especializada em documentação imobiliária e análise para aprovação de financiamento bancário. Onde seu trabalho abrange imóveis tanto na planta quanto prontos para morar, com especial enfoque no plano MINHA CASA MINHA VIDA.",
        project_tech: ["ANGULAR 17", "POCKETBASE", "BOOTSTRAP", "VERCEL", "SASS"]
    },
    {
        id: 789,
        layout: "big",
        animation_direction: "left",
        project_name: "Nebulum",
        project_url: "https://valdoveste.github.io/nebulum/",
        project_git_url: "https://github.com/Valdoveste/nebulum",
        project_img_alt: "Nebulum Project Image",
        project_img: "https://user-images.githubusercontent.com/62577482/145719124-01abeffd-3a16-489d-b9be-a5ea9e68c243.png",
        project_desc: "Um álbum de fotos online, onde uma dos principais objetivos durante seu desenvolvimento praticar minhas habilidades com clean design, javascript e com o consumo de API's. Um dos grande desafios durante o desenvolvimento foi tratar a imagens e dar uma preocupação extra para usuário mobile. Durante o tratamento das imagens foi utilizado loading lazy, placeholder baseado em sua cor média, e uma das funcionalidades para mobile é sua paginação que funciona com infinityScroll.",
        project_tech: ["JAVASCRIPT", "HTML5", "CSS3", "SASS"]
    },
    {
        id: 910,
        layout: "big",
        animation_direction: "right",
        project_name: "Five Senses Resorts",
        project_url: "https://valdoveste.github.io/fiveSensesResort/",
        project_git_url: "https://github.com/Valdoveste/fiveSensesResort",
        project_img_alt: "Fives Senses Resort Project Image",
        project_img: "https://user-images.githubusercontent.com/62577482/224366779-760839c3-bddf-4f6f-9cd3-f965b773d2c3.png",
        project_desc: "Five Senses Resort é uma apliação web utilizando o framework bootstrap, onde o objetivo foi montar um página que apresente as principais informações do primeiro Resort de Tocantins, o Five Senses veio com a necessidade do lazer no cotidiano do tocantinese em aproveitar o tempo em família e no descanso. A beleza natural do lago de Palmas e os encantos naturais da região criaram esse desejo de proporcionar um novo destino de férias.",
        project_tech: ["JAVASCRIPT", "HTML5", "CSS3", "SASS", "BOOTSTRAP"]
    }
];

export default PortfolioBigCards;